export default __webpack_public_path__ + "static/media/Tail of the Vaaghasan.9ae7f51d.jpg";